// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const TerraformIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#5C4EE5"
      fillRule="evenodd"
      d="m8.57 4.23 6.56 3.79v7.57l-6.56-3.78z"
      clipRule="evenodd"
    />
    <path
      fill="#4040B2"
      fillRule="evenodd"
      d="M15.84 8.02v7.57l6.57-3.78V4.23z"
      clipRule="evenodd"
    />
    <path
      fill="#5C4EE5"
      fillRule="evenodd"
      d="M1.29 0v7.58l6.56 3.79V3.79zM8.57 20.21 15.13 24v-7.569999999999999l-6.56-3.8z"
      clipRule="evenodd"
    />
  </svg>,
  "Terraform",
);
export default TerraformIcon;
